import { gridGapClasses } from '@/styles/grid';
import { Heading } from 'components/src/typography';
import { TraitsListFieldsFragment } from 'types/generated';
import Trait from './Trait';
import clsx from 'clsx';

type TraitsListProps = {
  data: TraitsListFieldsFragment;
};

const TraitsList = ({ data }: TraitsListProps) => {
  if (data.listOfTraitsCollection?.items?.length === 0) return null;
  return (
    <div className="my-32 gap-y-64 text-black-50">
      <div
        className={clsx(
          gridGapClasses,
          'col-span-full grid grid-cols-6 !gap-y-64 md:col-span-10 md:col-start-2 md:grid-cols-10'
        )}
      >
        {data.title && (
          <div className="col-span-full">
            <Heading variant="xs" classes="text-center">
              {data.title}
            </Heading>
          </div>
        )}
        <div className={clsx(gridGapClasses, '!md:gap-y-64 col-span-full grid grid-cols-6 !gap-y-24 md:grid-cols-12')}>
          {data.listOfTraitsCollection?.items?.map((trait) => <Trait trait={trait} key={trait?.id} />)}
        </div>
      </div>
    </div>
  );
};
export default TraitsList;
